// Admin panel i18n — task pages:
// AdminTasks (aTasks*), AdminOrderHistory (aHist*), AdminDashboard (aDash*)
const tasks = {
  vi: {
    // AdminTasks
    aTasksTitle: 'Nhiệm vụ Like/Review',
    aTasksSubtitle: 'Duyệt bằng chứng và quản lý kho nhiệm vụ',
    aTasksPendingReview: 'Chờ duyệt',
    aTasksInProgress: 'Đang làm',
    aTasksApproved: 'Đã duyệt',
    aTasksRejected: 'Từ chối',
    aTasksApprovedToday: 'Duyệt hôm nay',
    aTasksPaidToday: 'Trả hôm nay',
    aTasksActiveUsers: 'User hoạt động',
    aTasksReviewQueue: 'Hàng đợi duyệt',
    aTasksTaskPool: 'Kho nhiệm vụ',
    aTasksColProof: 'Bằng chứng',
    aTasksColUser: 'Người dùng',
    aTasksColTask: 'Nhiệm vụ',
    aTasksColReward: 'Thưởng',
    aTasksColSubmitted: 'Gửi lúc',
    aTasksColActions: 'Hành động',
    aTasksLoading: 'Đang tải...',
    aTasksNoRequests: 'Không có yêu cầu nào',
    aTasksNoProof: 'Chưa có',
    aTasksProcessing: 'Đang xử lý...',
    aTasksApprove: 'Duyệt',
    aTasksExpired: 'Hết thời gian',
    aTasksNoProofYet: 'Chưa gửi bằng chứng',
    aTasksColSlotsToday: 'Slot hôm nay',
    aTasksColLimitPerUser: 'Giới hạn/user',
    aTasksColStatus: 'Trạng thái',
    aTasksUsedN: 'đã dùng {n}',
    aTasksOpen: 'Đang mở',
    aTasksClosed: 'Tạm đóng',
    aTasksClose: 'Đóng',
    aTasksOpenBtn: 'Mở',
    aTasksResetSlot: 'Reset slot',
    aTasksToggleHot: "Đánh dấu hot",
    aTasksEnableAll: "Bật tất cả",
    aTasksEnableAllConfirm: "Bật toàn bộ {n} nhiệm vụ đang tạm dừng?",
    aTasksEnabledN: "Đã bật {n} nhiệm vụ",
    aTasksPausedCount: "{n} nhiệm vụ đang tạm dừng",
    aTasksSlotHint: 'Sửa ô slot rồi click ra ngoài để lưu.',
    aTasksRejectPrompt: 'Lý do từ chối:',
    aTasksRejectReasonDefault: 'Bằng chứng không hợp lệ',
    // AdminOrderHistory
    aHistTitle: 'Lịch sử Quay đơn',
    aHistSubtitle: 'Theo dõi lịch sử đơn hàng của người dùng',
    aHistTotalOrders: 'Tổng đơn quay',
    aHistPending: 'Đang xử lý',
    aHistCompleted: 'Hoàn thành',
    aHistTotalRevenue: 'Tổng doanh thu',
    aHistTotalCommission: 'Tổng hoa hồng',
    aHistSearchPlaceholder: 'Tìm kiếm theo tên user, số điện thoại...',
    aHistSearch: 'Tìm kiếm',
    aHistDeleteAllTitle: 'Xóa toàn bộ lịch sử quay đơn của tất cả user',
    aHistDeleteAll: 'Xóa Tất Cả',
    aHistColUser: 'Người dùng',
    aHistColProduct: 'Sản phẩm',
    aHistColPrice: 'Giá tiền',
    aHistColCommission: 'Hoa hồng',
    aHistColStatus: 'Trạng thái',
    aHistColDate: 'Ngày',
    aHistColActions: 'Hành động',
    aHistLoading: 'Đang tải dữ liệu...',
    aHistEmpty: 'Không có lịch sử đơn hàng',
    aHistDeleteUserTitle: 'Xóa toàn bộ lịch sử quay đơn của user này',
    aHistDeleteShort: 'Xóa LS',
    aHistShowing: 'Hiển thị {shown} / {total} đơn hàng',
    aHistPrev: 'Trước',
    aHistNext: 'Tiếp',
    aHistPageOf: 'Trang {page} / {total}',
    aHistConfirmDeleteUser: '⚠️ XÓA TOÀN BỘ LỊCH SỬ QUAY ĐƠN CỦA {username}?\n\nHành động này sẽ:\n- Xóa tất cả đơn hàng đã hoàn thành\n- Xóa tất cả đơn hàng đang chờ\n- Reset thống kê về 0\n\nKhông thể hoàn tác!',
    aHistDeletedUser: 'Đã xóa toàn bộ lịch sử quay đơn của {username}',
    aHistConfirmDeleteAll: '🚨 XÓA TOÀN BỘ LỊCH SỬ QUAY ĐƠN CỦA TẤT CẢ USER?\n\nHành động này sẽ:\n- Xóa TẤT CẢ đơn hàng đã hoàn thành\n- Xóa TẤT CẢ đơn hàng đang chờ\n- Reset thống kê của TẤT CẢ user về 0\n\nCỰC KỲ NGUY HIỂM - KHÔNG THỂ HOÀN TÁC!',
    aHistConfirmPromptAll: 'Nhập "XOA TAT CA" để xác nhận:',
    aHistCancelled: 'Hủy bỏ thao tác',
    aHistDeletedAll: 'Đã xóa toàn bộ lịch sử quay đơn của tất cả user',
    // AdminDashboard
    aDashLoading: 'Đang tải thống kê...',
    aDashError: 'Không thể tải thống kê',
    aDashTitle: 'Bảng điều khiển',
    aDashSubtitle: 'Tổng quan hệ thống',
    aDashTotalBalance: 'Tổng số dư',
    aDashOrdersToday: 'Đơn hàng hôm nay',
    aDashCompletedOrders: 'Đơn hoàn thành',
    aDashTotalUsers: 'Tổng người dùng',
    aDashTotalDeposit: 'Tổng nạp tiền',
    aDashTotalWithdraw: 'Tổng rút tiền',
    aDashPendingHeading: 'Yêu cầu chờ xử lý',
    aDashPendingText: '{deposits} nạp tiền và {withdraws} rút tiền đang chờ duyệt'
  },
  en: {
    // AdminTasks
    aTasksTitle: 'Like/Review tasks',
    aTasksSubtitle: 'Approve proofs and manage the task pool',
    aTasksPendingReview: 'Pending review',
    aTasksInProgress: 'In progress',
    aTasksApproved: 'Approved',
    aTasksRejected: 'Rejected',
    aTasksApprovedToday: 'Approved today',
    aTasksPaidToday: 'Paid today',
    aTasksActiveUsers: 'Active users',
    aTasksReviewQueue: 'Review queue',
    aTasksTaskPool: 'Task pool',
    aTasksColProof: 'Proof',
    aTasksColUser: 'User',
    aTasksColTask: 'Task',
    aTasksColReward: 'Reward',
    aTasksColSubmitted: 'Submitted at',
    aTasksColActions: 'Actions',
    aTasksLoading: 'Loading...',
    aTasksNoRequests: 'No requests',
    aTasksNoProof: 'None',
    aTasksProcessing: 'Processing...',
    aTasksApprove: 'Approve',
    aTasksExpired: 'Expired',
    aTasksNoProofYet: 'Proof not submitted',
    aTasksColSlotsToday: "Today's slots",
    aTasksColLimitPerUser: 'Limit/user',
    aTasksColStatus: 'Status',
    aTasksUsedN: 'used {n}',
    aTasksOpen: 'Open',
    aTasksClosed: 'Paused',
    aTasksClose: 'Close',
    aTasksOpenBtn: 'Open',
    aTasksResetSlot: 'Reset slots',
    aTasksToggleHot: "Mark hot",
    aTasksEnableAll: "Enable all",
    aTasksEnableAllConfirm: "Enable all {n} paused tasks?",
    aTasksEnabledN: "Enabled {n} tasks",
    aTasksPausedCount: "{n} tasks paused",
    aTasksSlotHint: 'Edit the slot field, then click outside to save.',
    aTasksRejectPrompt: 'Rejection reason:',
    aTasksRejectReasonDefault: 'Invalid proof',
    // AdminOrderHistory
    aHistTitle: 'Order history',
    aHistSubtitle: 'Track users\' order history',
    aHistTotalOrders: 'Total orders',
    aHistPending: 'Processing',
    aHistCompleted: 'Completed',
    aHistTotalRevenue: 'Total revenue',
    aHistTotalCommission: 'Total commission',
    aHistSearchPlaceholder: 'Search by username, phone number...',
    aHistSearch: 'Search',
    aHistDeleteAllTitle: 'Delete the entire order history of all users',
    aHistDeleteAll: 'Delete All',
    aHistColUser: 'User',
    aHistColProduct: 'Product',
    aHistColPrice: 'Price',
    aHistColCommission: 'Commission',
    aHistColStatus: 'Status',
    aHistColDate: 'Date',
    aHistColActions: 'Actions',
    aHistLoading: 'Loading data...',
    aHistEmpty: 'No order history',
    aHistDeleteUserTitle: 'Delete this user\'s entire order history',
    aHistDeleteShort: 'Delete',
    aHistShowing: 'Showing {shown} / {total} orders',
    aHistPrev: 'Prev',
    aHistNext: 'Next',
    aHistPageOf: 'Page {page} / {total}',
    aHistConfirmDeleteUser: '⚠️ DELETE THE ENTIRE ORDER HISTORY OF {username}?\n\nThis action will:\n- Delete all completed orders\n- Delete all pending orders\n- Reset statistics to 0\n\nCannot be undone!',
    aHistDeletedUser: 'Deleted the entire order history of {username}',
    aHistConfirmDeleteAll: '🚨 DELETE THE ENTIRE ORDER HISTORY OF ALL USERS?\n\nThis action will:\n- Delete ALL completed orders\n- Delete ALL pending orders\n- Reset statistics of ALL users to 0\n\nEXTREMELY DANGEROUS - CANNOT BE UNDONE!',
    aHistConfirmPromptAll: 'Type "XOA TAT CA" to confirm:',
    aHistCancelled: 'Operation cancelled',
    aHistDeletedAll: 'Deleted the entire order history of all users',
    // AdminDashboard
    aDashLoading: 'Loading statistics...',
    aDashError: 'Failed to load statistics',
    aDashTitle: 'Dashboard',
    aDashSubtitle: 'System overview',
    aDashTotalBalance: 'Total balance',
    aDashOrdersToday: 'Orders today',
    aDashCompletedOrders: 'Completed orders',
    aDashTotalUsers: 'Total users',
    aDashTotalDeposit: 'Total deposits',
    aDashTotalWithdraw: 'Total withdrawals',
    aDashPendingHeading: 'Pending requests',
    aDashPendingText: '{deposits} deposit(s) and {withdraws} withdrawal(s) awaiting approval'
  },
  ko: {
    // AdminTasks
    aTasksTitle: '좋아요/리뷰 미션',
    aTasksSubtitle: '증빙 심사 및 미션 보관함 관리',
    aTasksPendingReview: '심사 대기',
    aTasksInProgress: '진행 중',
    aTasksApproved: '심사 완료',
    aTasksRejected: '거절',
    aTasksApprovedToday: '오늘 심사 완료',
    aTasksPaidToday: '오늘 지급',
    aTasksActiveUsers: '활성 사용자',
    aTasksReviewQueue: '심사 대기열',
    aTasksTaskPool: '미션 보관함',
    aTasksColProof: '증빙',
    aTasksColUser: '사용자',
    aTasksColTask: '미션',
    aTasksColReward: '리워드',
    aTasksColSubmitted: '제출 시각',
    aTasksColActions: '작업',
    aTasksLoading: '로딩 중...',
    aTasksNoRequests: '요청이 없습니다',
    aTasksNoProof: '없음',
    aTasksProcessing: '처리 중...',
    aTasksApprove: '심사',
    aTasksExpired: '기한 초과',
    aTasksNoProofYet: '증빙 미제출',
    aTasksColSlotsToday: '오늘 슬롯',
    aTasksColLimitPerUser: '사용자별 제한',
    aTasksColStatus: '상태',
    aTasksUsedN: '{n}개 사용됨',
    aTasksOpen: '열림',
    aTasksClosed: '일시 중지',
    aTasksClose: '닫기',
    aTasksOpenBtn: '열기',
    aTasksResetSlot: '슬롯 초기화',
    aTasksToggleHot: "인기 지정",
    aTasksEnableAll: "전체 활성화",
    aTasksEnableAllConfirm: "일시중지된 {n}개 작업을 모두 활성화할까요?",
    aTasksEnabledN: "{n}개 작업을 활성화했습니다",
    aTasksPausedCount: "일시중지 {n}개 작업",
    aTasksSlotHint: '슬롯 값을 수정한 후 바깥을 클릭하면 저장됩니다.',
    aTasksRejectPrompt: '거절 사유:',
    aTasksRejectReasonDefault: '유효하지 않은 증빙',
    // AdminOrderHistory
    aHistTitle: '주문 기록',
    aHistSubtitle: '사용자 주문 기록 조회',
    aHistTotalOrders: '총 주문',
    aHistPending: '처리 중',
    aHistCompleted: '완료',
    aHistTotalRevenue: '총 매출',
    aHistTotalCommission: '총 커미션',
    aHistSearchPlaceholder: '사용자 이름, 전화번호로 검색...',
    aHistSearch: '검색',
    aHistDeleteAllTitle: '모든 사용자의 주문 기록 전체 삭제',
    aHistDeleteAll: '전체 삭제',
    aHistColUser: '사용자',
    aHistColProduct: '상품',
    aHistColPrice: '가격',
    aHistColCommission: '커미션',
    aHistColStatus: '상태',
    aHistColDate: '날짜',
    aHistColActions: '작업',
    aHistLoading: '데이터 로딩 중...',
    aHistEmpty: '주문 기록이 없습니다',
    aHistDeleteUserTitle: '이 사용자의 주문 기록 전체 삭제',
    aHistDeleteShort: '삭제',
    aHistShowing: '{total}건 중 {shown}건 표시',
    aHistPrev: '이전',
    aHistNext: '다음',
    aHistPageOf: '{total} 페이지 중 {page}',
    aHistConfirmDeleteUser: '⚠️ {username}의 주문 기록을 모두 삭제하시겠습니까?\n\n이 작업은:\n- 완료된 주문 전체 삭제\n- 대기 중인 주문 전체 삭제\n- 통계를 0으로 초기화\n\n되돌릴 수 없습니다!',
    aHistDeletedUser: '{username}의 주문 기록을 모두 삭제했습니다',
    aHistConfirmDeleteAll: '🚨 모든 사용자의 주문 기록을 모두 삭제하시겠습니까?\n\n이 작업은:\n- 완료된 주문 전체 삭제\n- 대기 중인 주문 전체 삭제\n- 모든 사용자의 통계를 0으로 초기화\n\n매우 위험하며 되돌릴 수 없습니다!',
    aHistConfirmPromptAll: '확인하려면 "XOA TAT CA"를 입력하세요:',
    aHistCancelled: '작업이 취소되었습니다',
    aHistDeletedAll: '모든 사용자의 주문 기록을 모두 삭제했습니다',
    // AdminDashboard
    aDashLoading: '통계 로딩 중...',
    aDashError: '통계를 불러올 수 없습니다',
    aDashTitle: '대시보드',
    aDashSubtitle: '시스템 개요',
    aDashTotalBalance: '총 잔액',
    aDashOrdersToday: '오늘 주문',
    aDashCompletedOrders: '완료 주문',
    aDashTotalUsers: '총 사용자',
    aDashTotalDeposit: '총 입금',
    aDashTotalWithdraw: '총 출금',
    aDashPendingHeading: '처리 대기 요청',
    aDashPendingText: '입금 {deposits}건, 출금 {withdraws}건 심사 대기 중'
  },
  ja: {
    // AdminTasks
    aTasksTitle: 'いいね/レビュータスク',
    aTasksSubtitle: '証拠の承認とタスクプールの管理',
    aTasksPendingReview: '審査待ち',
    aTasksInProgress: '対応中',
    aTasksApproved: '承認済み',
    aTasksRejected: '却下',
    aTasksApprovedToday: '本日承認',
    aTasksPaidToday: '本日支払',
    aTasksActiveUsers: 'アクティブユーザー',
    aTasksReviewQueue: '審査キュー',
    aTasksTaskPool: 'タスクプール',
    aTasksColProof: '証拠',
    aTasksColUser: 'ユーザー',
    aTasksColTask: 'タスク',
    aTasksColReward: '報酬',
    aTasksColSubmitted: '提出日時',
    aTasksColActions: '操作',
    aTasksLoading: '読み込み中...',
    aTasksNoRequests: 'リクエストはありません',
    aTasksNoProof: 'なし',
    aTasksProcessing: '処理中...',
    aTasksApprove: '承認',
    aTasksExpired: '期限切れ',
    aTasksNoProofYet: '証拠未提出',
    aTasksColSlotsToday: '本日のスロット',
    aTasksColLimitPerUser: '1人あたり制限',
    aTasksColStatus: 'ステータス',
    aTasksUsedN: '{n}件使用済み',
    aTasksOpen: '公開中',
    aTasksClosed: '一時停止',
    aTasksClose: '閉じる',
    aTasksOpenBtn: '開く',
    aTasksResetSlot: 'スロットリセット',
    aTasksToggleHot: "热门に設定",
    aTasksEnableAll: "すべて有効化",
    aTasksEnableAllConfirm: "一時停止中の{n}件をすべて有効にしますか?",
    aTasksEnabledN: "{n}件を有効にしました",
    aTasksPausedCount: "一時停止中 {n}件",
    aTasksSlotHint: 'スロット欄を編集し、外側をクリックすると保存されます。',
    aTasksRejectPrompt: '却下理由:',
    aTasksRejectReasonDefault: '証拠が無効です',
    // AdminOrderHistory
    aHistTitle: '注文履歴',
    aHistSubtitle: 'ユーザーの注文履歴を確認',
    aHistTotalOrders: '総注文数',
    aHistPending: '処理中',
    aHistCompleted: '完了',
    aHistTotalRevenue: '総売上',
    aHistTotalCommission: '総コミッション',
    aHistSearchPlaceholder: 'ユーザー名、電話番号で検索...',
    aHistSearch: '検索',
    aHistDeleteAllTitle: '全ユーザーの注文履歴をすべて削除',
    aHistDeleteAll: 'すべて削除',
    aHistColUser: 'ユーザー',
    aHistColProduct: '商品',
    aHistColPrice: '価格',
    aHistColCommission: 'コミッション',
    aHistColStatus: 'ステータス',
    aHistColDate: '日付',
    aHistColActions: '操作',
    aHistLoading: 'データを読み込み中...',
    aHistEmpty: '注文履歴がありません',
    aHistDeleteUserTitle: 'このユーザーの注文履歴をすべて削除',
    aHistDeleteShort: '削除',
    aHistShowing: '{total}件中 {shown}件を表示',
    aHistPrev: '前へ',
    aHistNext: '次へ',
    aHistPageOf: '{total}ページ中 {page}ページ',
    aHistConfirmDeleteUser: '⚠️ {username}の注文履歴をすべて削除しますか？\n\nこの操作は：\n- 完了した注文をすべて削除\n- 保留中の注文をすべて削除\n- 統計を0にリセット\n\n元に戻せません！',
    aHistDeletedUser: '{username}の注文履歴をすべて削除しました',
    aHistConfirmDeleteAll: '🚨 全ユーザーの注文履歴をすべて削除しますか？\n\nこの操作は：\n- 完了した注文をすべて削除\n- 保留中の注文をすべて削除\n- 全ユーザーの統計を0にリセット\n\n非常に危険な操作です - 元に戻せません！',
    aHistConfirmPromptAll: '確認のため「XOA TAT CA」と入力してください：',
    aHistCancelled: '操作をキャンセルしました',
    aHistDeletedAll: '全ユーザーの注文履歴をすべて削除しました',
    // AdminDashboard
    aDashLoading: '統計を読み込み中...',
    aDashError: '統計を読み込めません',
    aDashTitle: 'ダッシュボード',
    aDashSubtitle: 'システム概要',
    aDashTotalBalance: '総残高',
    aDashOrdersToday: '本日の注文',
    aDashCompletedOrders: '完了注文',
    aDashTotalUsers: '総ユーザー数',
    aDashTotalDeposit: '総入金',
    aDashTotalWithdraw: '総出金',
    aDashPendingHeading: '処理待ちリクエスト',
    aDashPendingText: '入金 {deposits}件と出金 {withdraws}件の承認待ち'
  },
  zh: {
    // AdminTasks
    aTasksTitle: '点赞/评价任务',
    aTasksSubtitle: '审核凭证并管理任务库',
    aTasksPendingReview: '待审核',
    aTasksInProgress: '进行中',
    aTasksApproved: '已通过',
    aTasksRejected: '已拒绝',
    aTasksApprovedToday: '今日已审',
    aTasksPaidToday: '今日已付',
    aTasksActiveUsers: '活跃用户',
    aTasksReviewQueue: '审核队列',
    aTasksTaskPool: '任务库',
    aTasksColProof: '凭证',
    aTasksColUser: '用户',
    aTasksColTask: '任务',
    aTasksColReward: '奖励',
    aTasksColSubmitted: '提交时间',
    aTasksColActions: '操作',
    aTasksLoading: '加载中...',
    aTasksNoRequests: '暂无申请',
    aTasksNoProof: '暂无',
    aTasksProcessing: '处理中...',
    aTasksApprove: '通过',
    aTasksExpired: '已超时',
    aTasksNoProofYet: '未提交凭证',
    aTasksColSlotsToday: '今日名额',
    aTasksColLimitPerUser: '每人限额',
    aTasksColStatus: '状态',
    aTasksUsedN: '已用 {n}',
    aTasksOpen: '开启中',
    aTasksClosed: '已暂停',
    aTasksClose: '关闭',
    aTasksOpenBtn: '开启',
    aTasksResetSlot: '重置名额',
    aTasksToggleHot: "设为热门",
    aTasksEnableAll: "一键开启",
    aTasksEnableAllConfirm: "确定开启全部 {n} 个已暂停任务?",
    aTasksEnabledN: "已开启 {n} 个任务",
    aTasksPausedCount: "{n} 个任务已暂停",
    aTasksSlotHint: '修改名额后点击外部即可保存。',
    aTasksRejectPrompt: '拒绝原因：',
    aTasksRejectReasonDefault: '凭证无效',
    // AdminOrderHistory
    aHistTitle: '刷单历史',
    aHistSubtitle: '跟踪用户订单历史',
    aHistTotalOrders: '刷单总数',
    aHistPending: '处理中',
    aHistCompleted: '已完成',
    aHistTotalRevenue: '总营业额',
    aHistTotalCommission: '总佣金',
    aHistSearchPlaceholder: '按用户名、手机号搜索...',
    aHistSearch: '搜索',
    aHistDeleteAllTitle: '删除所有用户的全部刷单历史',
    aHistDeleteAll: '全部删除',
    aHistColUser: '用户',
    aHistColProduct: '商品',
    aHistColPrice: '价格',
    aHistColCommission: '佣金',
    aHistColStatus: '状态',
    aHistColDate: '日期',
    aHistColActions: '操作',
    aHistLoading: '正在加载数据...',
    aHistEmpty: '暂无订单历史',
    aHistDeleteUserTitle: '删除该用户的全部刷单历史',
    aHistDeleteShort: '删除',
    aHistShowing: '显示 {shown} / {total} 条订单',
    aHistPrev: '上一页',
    aHistNext: '下一页',
    aHistPageOf: '第 {page} / {total} 页',
    aHistConfirmDeleteUser: '⚠️ 删除 {username} 的全部刷单历史？\n\n此操作将：\n- 删除所有已完成订单\n- 删除所有待处理订单\n- 统计重置为 0\n\n无法撤销！',
    aHistDeletedUser: '已删除 {username} 的全部刷单历史',
    aHistConfirmDeleteAll: '🚨 删除所有用户的全部刷单历史？\n\n此操作将：\n- 删除所有已完成订单\n- 删除所有待处理订单\n- 所有用户统计重置为 0\n\n极其危险 - 无法撤销！',
    aHistConfirmPromptAll: '输入 "XOA TAT CA" 以确认：',
    aHistCancelled: '操作已取消',
    aHistDeletedAll: '已删除所有用户的全部刷单历史',
    // AdminDashboard
    aDashLoading: '正在加载统计...',
    aDashError: '无法加载统计',
    aDashTitle: '仪表板',
    aDashSubtitle: '系统概览',
    aDashTotalBalance: '总余额',
    aDashOrdersToday: '今日订单',
    aDashCompletedOrders: '已完成订单',
    aDashTotalUsers: '总用户数',
    aDashTotalDeposit: '总充值',
    aDashTotalWithdraw: '总提现',
    aDashPendingHeading: '待处理申请',
    aDashPendingText: '{deposits} 笔充值和 {withdraws} 笔提现待审核'
  }
};

export default tasks;
